module.exports = __webpack_public_path__ + "img/search-24px.db5d8122.svg";